<!--
 * @Description: Jeson Create File
 * @Version: 1.0
 * @Autor: Jeson
 * @Date: 2022-01-08 15:56:53
 * @LastEditors: Jeson
 * @LastEditTime: 2022-01-24 15:20:29
-->
<template>
  <div class="bgf5">
    <iHeader />
    <iNav />
    <iClassify ref="iClassify" :active="activeIndex" all-active />
    <iRightFixedBox />
    <iHomeAdCarousel v-if="true" ref="iHomeAdCarousel" />
    <div style="min-height: 600px;">
      <div id="FactoryList">
        <div class="search_div">
          <div class="search_div_item">
            <el-input v-model="search.ManufacturerName" placeholder="请输入内容" class="input-with-select">
              <el-button slot="append" icon="el-icon-search" @click.stop="searchBtn" />
            </el-input>
          </div>
        </div>
        <div v-for="(item, index) in list" :key="index" class="factory-div">
          <div class="factory-div-title" :style="{background:background[index]}">
            <div>
              <img :src="item.Logo">
              <div>{{ item.BrandName }}</div>
            </div>
            <div @click.stop="more(item)">查看更多 ></div>
          </div>
          <div class="factory-div-content">
            <div

              v-for="(item, index) in item.Goods"
              :key="index"
              class="factory-div-content-good"
            >
              <NewProductItem v-if="index<6" :product="item" />
            </div>
            <div
              v-for="(t, j) in (5)"
              v-if="0<item.Goods<5"
              :key="`ZSSS-${j}`"
              style="height: 100%;"
              class="storey-tabs-item"
            >
              <div class="noproduct_div_noacross">
                <div>产品上架中...</div>
              </div>
            </div>
          </div>
        </div>
        <EmptyControl v-if="!list.length" style="margin: 20px 0; padding: 100px 0; width: 1200px;" type="goods" text="没有找到商品哦~" />
      </div>
    </div>
    <iFooter />
    <add-new-goods-collect-tips ref="addNewCollectTipsRef" />
  </div>
</template>

<script>
import iHeader from '@/components/Header'
import iNav from '@/components/Nav'
import iClassify from '@/components/Classify'
import iFooter from '@/components/Footer'
import { BaseMixin } from '@/mixins/BaseMixin'
import iHomeAdCarousel from '@/views/home/HomeAdCarousel.vue'
import AddNewGoodsCollectTips from '@/components/AddNewGoodsCollectTips.vue'
import iRightFixedBox from '@/components/RightFixedBox'

export default {
  name: 'BrandList',
  components: {
    iHeader,
    iNav,
    iClassify,
    iFooter,
    AddNewGoodsCollectTips,
    iHomeAdCarousel,
    iRightFixedBox

  },
  mixins: [BaseMixin],
  data() {
    return {
      search: {
        Offset: 0,
        ManufacturerName: ''
      },
      activeIndex: 1,
      list: [],
      Goods: [],
      IsHasNext: false,
      loading: false,
      background: ['#fddad8', '#d6e6fd', '#fcd8a7', '#fddad8', '#d6e6fd', '#fcd8a7'],
      // 搜索menu是否需要固定标记,默认false
      isFixedMenu: false,
      // 搜索组件样式类型, 传seckill代表秒杀，传空代表其余的活动板块
      searchStyleType: ''

    }
  },
  watch: {},
  destroyed() {},
  created() {},
  beforeDestroy() {},
  mounted() {
    this.getHomePageShowData()
    // 绑定监听页面滑动方法
    window.addEventListener('scroll', this.handleSearch)
    this.getBrandList()
  },
  methods: {

    more(item) {
      this.$router.push({
        path: 'BrandMoreList',
        query: { Id: item.Id, BrandName: item.BrandName, Logo: item.Logo }
      })
    },
    searchBtn() {
      this.search.Offset = 0
      this.list = []
      // 获取list
      this.getBrandList()
    },
    async getBrandList() {
      this.loading = true
      const res = await this.getAction('/clientapi_brand/Brand/getbrandlist', this.search)
      if (res.IsSuccess) {
        res.Data.List.map(oo => {
          this.list.push(oo)
        })
        this.IsHasNext = res.Data.IsHasNext
        this.search.Offset = res.Data.Offset
        this.loading = false
      }
    },
    // 获取首页展示数据 轮播图 广告图 分类导航
    async getHomePageShowData() {
      const res = await this.getAction(
        '/api_basedata/HomePage/GetAdvertisingPageV2', {
          codes: 'brand7_1'
        }
      )
      if (res.IsSuccess) {
        if (this.$refs['iHomeAdCarousel']) {
          this.$refs['iHomeAdCarousel'].init(res.Data)
        }
      } else {
        this.$toast({ position: 'bottom', message: res.Msg })
      }
    },
    /*
     * 监听页面滑动
     */
    handleSearch() {
      // 获取当前页面高度
      const scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop

      // 获取网页可见区域高
      const clientHeight = document.body.clientHeight
      // 获取网页正文全文高
      const scrollHeight = document.body.scrollHeight

      // 当前页面高度大于指定位置时记录

      // 到达页面底部时
      if (scrollTop + clientHeight + 400 >= scrollHeight) {
        if (this.IsHasNext && this.loading === false) {
          this.getBrandList()
        }
      }
    }
  }
}
</script>

<style lang="less" scoped>
#FactoryList {
  margin: auto;
  width: 1200px;
  max-width: 1200px;

  .search_div {
    width: 100%;

    .search_div_item {
      margin-top: 10px;
      margin-left: calc(100% - 500px);
      width: 500px;

      /deep/.el-button {
        border: 1px solid #0F6EE9;
        background: #0F6EE9;
        border-top-left-radius: 0;
        border-bottom-left-radius: 0;
      }

      /deep/.el-icon-search {
        color: white;
      }
    }
  }

  .factory-div {
    overflow: hidden;
    margin-top: 17px;
    border-radius: 2px;
    height: 529px;
    background: #FFFFFF;

    .factory-div-title {
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 80px;

      :nth-child(1) {
        display: flex;
        align-items: center;

        div {
          font-size: 24px;
          font-weight: 600;
          color: #111A34;
        }
      }

      :nth-child(2) {
        margin-right: 22px;
        font-size: 18px;
        font-weight: 500;
        color: #666F83;
      }

      img {
        margin-right: 15px;
        margin-left: 22px;
        border-radius: 10px;
        width: 80px;
        height: 60px;
      }
    }

    .factory-div-content {
      display: flex;
      height: calc(100% - 80px);

      .factory-div-content-good {
        padding-top: 8px;
        width: 240px;
      }
    }
  }

  .noproduct_div_noacross {
    padding: 8px;
    width: 240px;
    height: 100%;

    div {
      border: 1px solid #F3F5F7;
      padding-top: 140%;
      width: 100%;
      height: 100%;
      font-weight: 400;
      color: #666F83;
      background-position: 50%;
      background-repeat: no-repeat;
      background-size: 100%;
      background-image: url('../../assets/home/noproduct.png');
      line-height: 14px;
    }
  }
}

.storey-tabs-item {
  width: 240px;
}
</style>
